import {
  jb_contact_grid_css_default
} from "./chunk.35JJTJDH.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.6ORGI2J5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-contact-grid/jb-contact-grid.ts
var JbContactGrid = class extends ChangesBackgroundColor(Spaceable(r)) {
  _getContentSpacingProperties() {
    return { colsMdUp: 10, grid: "legacy" };
  }
  render() {
    return ke`
      <section>
        <div class="container">
          ${this.headline ? ke`<div class="headline"><jb-section-headline .headline=${this.headline}></jb-section-headline></div>` : D}
          <div class="${Rt({ one: this.columns === 1, two: this.columns === 2, content: true })}">
            <slot></slot>
          </div>
        </div>
      </section>
    `;
  }
};
JbContactGrid.styles = jb_contact_grid_css_default;
__decorateClass([
  n({ type: Number })
], JbContactGrid.prototype, "columns", 2);
__decorateClass([
  n()
], JbContactGrid.prototype, "headline", 2);
JbContactGrid = __decorateClass([
  customElement("jb-contact-grid")
], JbContactGrid);

export {
  JbContactGrid
};
